import React, { useEffect, useState } from 'react';
import { useAgentAuth } from '../../contexts/AgentAuthContext';
import AgentLayout from './AgentLayout';

const API = process.env.REACT_APP_BACKEND_URL;

const AgentOrders = () => {
  const { agentToken } = useAgentAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!agentToken) return;
    (async () => {
      try {
        const r = await fetch(`${API}/api/agent/orders`, { headers: { Authorization: `Bearer ${agentToken}` } });
        const j = await r.json();
        setOrders(j.data || []);
      } finally { setLoading(false); }
    })();
  }, [agentToken]);

  const eur = (v) => Number(v || 0).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });

  return (
    <AgentLayout>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Ordini</h1>
        <p className="text-sm text-gray-600 mt-1">{orders.length} ordini dei tuoi clienti.</p>
      </div>
      <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
        {loading ? (
          <div className="py-16 text-center text-gray-500">Caricamento…</div>
        ) : orders.length === 0 ? (
          <div className="py-16 text-center text-gray-500">Nessun ordine in portafoglio.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-purple-50/50 text-purple-700 uppercase text-[10px]">
              <tr>
                <th className="text-left px-4 py-3">N°</th>
                <th className="text-left px-4 py-3">Cliente</th>
                <th className="text-left px-4 py-3">Stato</th>
                <th className="text-right px-4 py-3">Totale</th>
                <th className="text-left px-4 py-3">Data</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {orders.map((o) => (
                <tr key={o.id} className="hover:bg-purple-50/40" data-testid={`order-row-${o.id}`}>
                  <td className="px-4 py-3 font-mono text-xs text-purple-700">{o.orderNumber}</td>
                  <td className="px-4 py-3">
                    <div className="text-gray-900">{o.customer?.firstName} {o.customer?.lastName}</div>
                    <div className="text-[11px] text-gray-500">{o.customer?.email}</div>
                  </td>
                  <td className="px-4 py-3">
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-700">
                      {o.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right font-semibold tabular-nums">{eur(o.totalAmount)}</td>
                  <td className="px-4 py-3 text-xs text-gray-500">
                    {o.createdAt ? new Date(o.createdAt).toLocaleDateString('it-IT') : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AgentLayout>
  );
};

export default AgentOrders;
